// src/services/pushAPI.js
//
// /api/push — Web Push opt-in for the signed-in patient or subscriber.
// Staff get 403 from every one of these (the backend does not support them yet).

import api from './api';

export const pushAPI = {
  config:      ()         => api.get('/push/config'),
  subscribe:   (sub)      => api.post('/push/subscriptions', sub),
  // `token` is only for logout, where the stored token is cleared before this
  // request is actually sent; the request interceptor won't overwrite an explicit header.
  unsubscribe: (endpoint, token) => api.delete('/push/subscriptions', {
    params: { endpoint },
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
  }),
  test:        ()         => api.post('/push/test'),
};
